import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";

import EditGenerateInvoice from "../pages/jobs/EditGenerateInvoice";
import GenerateInvoice from "../pages/jobs/GenerateInvoice";
import InvoiceToPdf from "../pages/jobs/InvoiceToPdf";
import JobEdit from "../pages/jobs/JobEdit";
import JobsCreate from "../pages/jobs/JobsCreate";
import ContractsCreate from "../pages/jobs/ContractsCreate";
import JobsView from "../pages/jobs/JobsView";
import PoRequest from "../pages/jobs/PoRequest";
import ReceivePO from "../pages/jobs/ReceivePO";
import Contracts from "../pages/organizations/Contracts";
import Organization from "../pages/organizations/Organization";
import OrganizationCreate from "../pages/organizations/OrganizationCreate";
import OrganizationView from "../pages/organizations/OrganizationView";
import ContractView from "../pages/jobs/ContractsView";
import ContractsEdit from "../pages/jobs/ContractsEdit";
import JobCompletionReportPdf from "../pages/jobs/JobCompletionReportPdf";

export default function OrganizationRoutes() {
  return (
    <Routes>
      <Route path="" element={<Organization />} />
      <Route path="/create" element={<OrganizationCreate />} />
      <Route path="/view/:organization_id" element={<OrganizationView />} />
      <Route path="/contracts/:organization_id" element={<Contracts />} />
      <Route path="/view/:organization_id/createJob" element={<JobsCreate />} />
      <Route
        path="/contracts/:organization_id/createContract"
        element={<ContractsCreate />}
      />
      <Route path="/view/:organization_id/jobs/:job" element={<JobsView />} />
      <Route
        path="/view/:organization_id/contract/:contractId"
        element={<ContractView />}
      />
      <Route
        path="/view/:organization_id/contract/:contract/edit"
        element={<ContractsEdit />}
      />
      <Route
        path="/view/:organization_id/jobs/:job/edit"
        element={<JobEdit />}
      />
      <Route
        path="/view/:organization_id/jobs/:job/receivePO"
        element={<ReceivePO />}
      />
      <Route
        path="/view/:organization_id/jobs/:job/request"
        element={<PoRequest />}
      />
      <Route
        path="/view/:organization_id/jobs/:job/invoice"
        element={<GenerateInvoice />}
      />
      <Route
        path="/view/:organization_id/jobs/:job/invoiceToPdf/edit"
        element={<EditGenerateInvoice />}
      />
      <Route
        path="/view/:organization_id/jobs/:job/invoiceToPdf"
        element={<InvoiceToPdf />}
      />
      <Route
        path="/view/:organization_id/jobs/:job/completionReportPdf"
        element={<JobCompletionReportPdf />}
      />
      <Route
        path="/view/:organization_id/contract/:contractId/completionReportPdf"
        element={<JobCompletionReportPdf />}
      />

      {/* Redirect root to organizations */}
      <Route path="/" element={<Navigate to="/organizations" replace />} />
    </Routes>
  );
}
